import React, { useEffect, useRef, useState } from "react";

/**
 * Selector de columnas visibles de una tabla.
 *
 * La selección se guarda en la base por usuario y por tabla, así que cada quien
 * ve la tabla como la dejó la última vez, desde cualquier navegador.
 *
 * No permite apagar la última columna: una tabla sin columnas no se puede
 * volver a configurar desde la propia tabla.
 */
export default function ColumnPicker({ columns, visibles, onToggle, onMostrarTodas }) {
  const [abierto, setAbierto] = useState(false);
  const caja = useRef(null);

  useEffect(() => {
    if (!abierto) return;

    const alClicFuera = (e) => {
      if (caja.current && !caja.current.contains(e.target)) setAbierto(false);
    };
    const alEscape = (e) => {
      if (e.key === "Escape") setAbierto(false);
    };

    document.addEventListener("mousedown", alClicFuera);
    document.addEventListener("keydown", alEscape);

    return () => {
      document.removeEventListener("mousedown", alClicFuera);
      document.removeEventListener("keydown", alEscape);
    };
  }, [abierto]);

  const ocultas = columns.length - visibles.length;

  return (
    <div className="dtable-columnas" ref={caja}>
      <button
        type="button"
        className="dtable-columnas-btn"
        onClick={() => setAbierto((v) => !v)}
        aria-expanded={abierto}
      >
        <i className="bi bi-layout-three-columns" aria-hidden="true"></i>
        Columnas
        {ocultas > 0 && <span className="dtable-columnas-cuenta">{ocultas}</span>}
      </button>

      {abierto && (
        <div className="dtable-columnas-panel" role="group" aria-label="Columnas visibles">
          <div className="dtable-columnas-lista">
            {columns.map((col) => {
              const activa = visibles.includes(col.field);
              const esLaUltima = activa && visibles.length === 1;

              return (
                <label
                  key={col.field}
                  className={`dtable-columnas-item ${esLaUltima ? "is-bloqueada" : ""}`}
                  title={esLaUltima ? "Debe quedar al menos una columna" : undefined}
                >
                  <input
                    type="checkbox"
                    checked={activa}
                    disabled={esLaUltima}
                    onChange={() => onToggle(col.field)}
                  />
                  <span>{col.title || col.field}</span>
                </label>
              );
            })}
          </div>

          {ocultas > 0 && (
            <button
              type="button"
              className="dtable-columnas-todas"
              onClick={onMostrarTodas}
            >
              Mostrar todas
            </button>
          )}
        </div>
      )}
    </div>
  );
}
